import { RouteRecordRaw } from 'vue-router'

import { SHOWS_ROUTE_NAMES } from '@/modules/show/constants/ShowRouteName'

import { UserGroup } from '@generated/types'

export const showRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/shows/:showId/performance/add',
    name: 'performanceAdd',
    component: () => import('@/modules/show/pages/ShowPerformanceAdd.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Add Performance',
    },
  },
  {
    path: '/venue/shows/',
    meta: { requiresAuth: UserGroup.MANAGERS, pageTitle: 'Shows', usesCustomNavbar: true },
    children: [
      {
        path: '',
        name: SHOWS_ROUTE_NAMES.LIST,
        component: () => import('@/modules/show/pages/ShowListNew.vue'),
        meta: { requiresAuth: UserGroup.MANAGERS, pageTitle: 'Show List' },
      },
      {
        path: ':showId(\\d+)',
        name: SHOWS_ROUTE_NAMES.DETAIL,
        component: () => import('@/modules/show/pages/ShowDetailNew.vue'),
        props: route => ({ showId: +route.params.showId }),
        meta: { requiresAuth: UserGroup.MANAGERS, pageTitle: 'Show Detail' },
      },
    ],
  },
]
